/**
 * DrawControl — wraps @mapbox/mapbox-gl-draw as a react-map-gl control for
 * drawing/editing sub-zone polygons.
 *
 * Customizations over stock mapbox-gl-draw:
 *  - right-click on a vertex deletes it (while keeping at least a triangle)
 *  - the "subzone_movable" localStorage flag (Settings page, default on)
 *    disables whole-polygon dragging when off, so users can't accidentally
 *    displace an area while clicking around
 *  - when `initialPoints` is set (editing an existing sub-zone) the polygon
 *    is preloaded and opened directly in vertex-editing mode
 */
import MapboxDraw from '@mapbox/mapbox-gl-draw';
import { useControl } from 'react-map-gl';

export default function DrawControl(props) {
  /**
   * @type { MapboxDraw | null }
   */
  let draw = null;
  // let modeTimeout = undefined;
  const editTargetFeatureId = "edit-target";
  useControl(
    () => {
      // console.log("DrawControl.onCreate");
      const optionalOverrideDrawFeature = (localStorage.getItem("subzone_movable") || "1") === "1" ? {} : {dragFeature() {}, dragMove() {}};
      let drawParams = {
        ...props,
        modes: {
          ...MapboxDraw.modes,
          simple_select: { ...MapboxDraw.modes.simple_select, ...optionalOverrideDrawFeature },
          direct_select: { ...MapboxDraw.modes.direct_select, ...optionalOverrideDrawFeature,
            onClick(state, e) {
              if (e.originalEvent.button === 2) {
                // console.log("RIght click!!", state, e);
                if (state.selectedCoordPaths && state.feature.coordinates[0]?.length > 3) {
                  state.feature.removeCoordinate(state.selectedCoordPaths[0]);
                  this.fireUpdate();
                }
              } else {
                MapboxDraw.modes.direct_select.onClick?.call(this, state, e);
              }
            }
          },
          ...(props.modes || {}),
        }
      };
      if (props.initialPoints?.length) {
        drawParams.defaultMode = "simple_select";
      }
      return draw = new MapboxDraw(drawParams);
    },
    ({ map }) => {
      // console.log("DrawControl.onAdd");
      // /*modeTimeout = */setInterval(() => {
      //   console.log("Draw mode:", draw.getMode());
      // }, 2000);
      map.on('draw.create', props.onCreate);
      map.on('draw.update', props.onUpdate);
      map.on('draw.delete', props.onDelete);
      if (props.initialPoints?.length) {
        draw.set({
          type: "FeatureCollection",
          features: [{
            type: "Feature",
            properties: {},
            id: editTargetFeatureId,
            geometry: {
              type: "Polygon",
              coordinates: [props.initialPoints]
            }
          }]
        });
        draw.changeMode("direct_select", { featureId: editTargetFeatureId });
      }
    },
    ({ map }) => {
      // console.log("DrawControl.onRemove");
      // if (modeTimeout !== undefined) {
      //   clearTimeout(modeTimeout);
      // }
      map.off('draw.create', props.onCreate);
      map.off('draw.update', props.onUpdate);
      map.off('draw.delete', props.onDelete);
    },
    {
      position: props.position
    }
  );

  return null;
}